import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    lng: 'nb',
    fallbackLng: 'nb',
    debug: true,
    interpolation: {
        escapeValue: false,
    },
    resources: {
        nb: {
            translation: {
                laaneramme: {
                    boliglaanKalkulator: 'Boliglånskalkulator',
                    hvorMyeKanJegLaane: 'Hvor mye kan jeg låne?',
                    hvaKosterLaanet: 'Hva koster lånet?',
                    antallLaantakere: 'Antall låntakere',
                    antallBarn: 'Antall barn under 18 år',
                    antallBiler: 'Antall biler',
                    ingen: 'Ingen',
                    samletAarsinntektFoerSkatt: 'Samlet årsinntekt før skatt',
                    samletGjeld: 'Samlet gjeld',
                    samletGjeldSublabel: 'Du trenger ikke føre opp gjeld som innfris ved utbetaling av nytt boliglån.',
                    laanerammeSpoersmaal: 'Fyll ut feltene for å se hvor mye vi tror du kan låne.',
                    laanerammeSvar: 'Vi tror du kan låne',
                    laanerammeSvarIkkeLaan: 'Basert på de valgte verdiene ser det ikke ut til at vi kan tilby lån.',
                    laanerammeFeilmelding: 'Vi klarer ikke å hente hvor mye du kan låne, prøv igjen seinere.',
                    soekBoliglaan: 'Søk boliglån',
                },
                laanekostnad: {
                    annen: 'Annen',
                    aar: 'år',
                    maanedligKostnad: 'Månedlig kostnad',
                    nedbetalingstid: 'Nedbetalingstid',
                    nedbetalingstidRequired: 'Vennligst fyll ut dette feltet',
                    nedbetalingstidError: 'Nedbetalingstid må være mindre enn eller lik 30 år',
                    oensketLaanebeloep: 'Ønsket lånebeløp',
                    oensketNedbetalingstid: 'Ønsket nedbetalingstid',
                    rentePaaLaanet: 'Rente på lånet',
                    rentePaaLaanetSubLabel: 'Din økonomi må tåle en renteøkning på minimum 3%',
                    renteTilbakestill: 'Tilbakestill rente',
                    vent: 'Vent...',
                },
                nedbetalingsplan: {
                    nedbetalingsplan: 'Nedbetalingsplan',
                    lukk: 'Lukk',
                    lukkNedbetalingsplan: 'Lukk nedbetalingsplan',
                    visNedbetalingsplan: 'Vis nedbetalingsplan',
                    aar: 'År',
                    aaBetale: 'Å betale',
                    avdrag: 'Avdrag',
                    renterOgGebyr: 'Renter og gebyrer',
                    restgjeld: 'Restgjeld',
                },
            },
        },
    },
});

export default i18n;
